module.exports = __webpack_public_path__ + "static/img/bulletin-boards-and-bulletin-cases.f03f005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/mountings/bulletin-boards-and-bulletin-cases.jpg
// module id = 679
// module chunks = 0